export default class SpecialCharCheck {


    /**
     *
     * 檢查傳入的字串中有無包含特殊字元
     * @param {string} msg
     * @return {boolean} true: 有特殊字元; false: 沒有特殊字元
     * @memberof SpecialCharCheck
     */
    checkSpecial(msg) {
        let pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
        return pattern.test(msg);
    }
}